// extracted by mini-css-extract-plugin
module.exports = {"block":"_10773","item":"_5602","value":"_19757"};